import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    path: String,
    loop: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: true }
  }

  connect() {
    this.animation = lottie.loadAnimation({
      container: this.containerTarget,
      renderer: 'svg',
      loop: this.loopValue,
      autoplay: this.autoplayValue,
      path: this.pathValue
    })
  }

  disconnect() {
    if (this.animation) {
      this.animation.destroy()
    }
  }

  play() {
    this.animation.play()
  }

  pause() {
    this.animation.pause()
  }

  stop() {
    this.animation.stop()
  }
}